import { tableCellClasses, typographyClasses } from "@mui/material"

export const gray = {
  color: "gray !important",
}

export const orange = {
  color: "orange !important",
}

export const green = {
  color: "green !important",
}

export const boxWrapper = {
  mb: 4,
  display: "flex",
  flexDirection: { xs: "column", lg: "row" },
  gap: { xs: 4, lg: 3, xl: 4 },
}

export const flexBasis = {
  flexBasis: "50%",
}

export const tableBodyRow = {
  [`& .${tableCellClasses.root}`]: {
    border: "none",
    padding: 0,
  },
  verticalAlign: "middle",
}

export const textCenter = {
  textAlign: "center",
}

export const iconWrapper = {
  display: "flex",
  alignItems: "center",
  gap: 1,
}

export const iconName = {
  fontSize: { xs: 16, sm: 14, xl: 16 },
}

export const boldCenterCell = {
  ...textCenter,
  fontSize: { xs: 14, md: 13, xl: 14 },
  fontWeight: 700,
}

export const boldLeftCell = {
  textAlign: "left",
  fontSize: { xs: 14, md: 13, xl: 14 },
  fontWeight: 600,
}

export const greenBoldCenterCell = {
  ...textCenter,
  fontSize: { xs: 14, md: 13, xl: 14 },
  fontWeight: 700,
  color: "green",
}

export const flexWrapper = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: 0.5,
}

export const semiBoldCenterCell = {
  ...textCenter,
  fontSize: { xs: 14, md: 13, xl: 14 },
  fontWeight: 600,
}

export const semiBoldLeftCell = {
  textAlign: "left",
  fontSize: { xs: 14, md: 13, xl: 14 },
  fontWeight: 600,
}

export const ltvWrapper = {
  display: "flex",
  gap: 0.25,
  alignItems: "center",
  justifyContent: "center",
}

export const supplyAPYWrapper = {
  display: "flex",
  alignItems: "center",
  justifyContent: { xs: "end", sm: "center" },
  gap: 0.25,
}

export const greenBold = {
  ...green,
  fontWeight: 700,
}

export const orangeBold = {
  ...orange,
  fontWeight: 700,
}

export const earnedAPY = {
  ...gray,
  fontWeight: 500,
  fontSize: 12,
}

export const earnedReward = {
  ...orange,
  fontSize: 12,
}

export const orangeLink = {
  ...orangeBold,
  fontWeight: 400,
  textDecorationColor: "rgba(255,255,255)",
}

export const actionsWrapper = {
  ...iconWrapper,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  "& .MuiButton-root": {
    fontSize: { xs: 14, md: 13, xl: 14 },
    fontWeight: 500,
  },
}

// Mobile
export const boxMobileWrapper = {
  display: "flex",
  flexDirection: { xs: "column", lg: "row" },
  background: "white",
}

export const mobileCardWrapper = {
  p: 4,
  display: "flex",
  flexDirection: "column",
  gap: 1,
  borderTop: "1px solid #DCDCDC",
}

export const titleItemWrapper = {
  backgroundColor: "white",
  display: "flex",
}

export const titleMobile = {
  flex: 1,
  py: 2,
  px: 4,
  fontSize: 20,
  fontWeight: 700,
}

export const statWrapper = {
  px: 0,
  py: 1,
}

export const statTitleGray = {
  color: "tableTitleGray",
  fontSize: 12,
}

export const mobileSymbol = {
  fontSize: 18,
  textWrap: "nowrap",
}

export const selectHeaderWrapper = {
  "&.MuiTableCell-root": {
    p: 1,
  },
}

export const selectBox = {
  minHeight: 29,
  "& .MuiSelect-select": {
    display: "flex",
    alignItems: "center",
    gap: 0.5,
    px: 1,
    py: 0.25,
    backgroundColor: "white",
  },
  "&.MuiInputBase-root.Mui-focused": {
    ".MuiOutlinedInput-notchedOutline": {
      border: 0,
    },
    "& .MuiInputBase-input": {
      border: "1px solid black",
    },
  },
  [`& .MuiInputBase-input.Mui-disabled`]: {
    cursor: "not-allowed",
  },
}

export const selectTokenWrapper = {
  textAlign: { xs: "end", lg: "center" },
}

export const selectTokenVolume = {
  fontSize: { xs: 14, md: 13, xl: 14 },
  display: "inline-block",
  fontWeight: 600,
}

export const selectTokenUSD = {
  [`&.${typographyClasses.body1}`]: {
    fontSize: 13,
  },
  color: "gray",
}
